import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {IFileModel} from '../interface/IFileModel';
import {FileManagerConfiguration} from '../../configuration/fileManagerConfiguration.service';
import {IFileEvent} from '../interface/IFileEvent';
import {Store} from '@ngrx/store';
import {IFileManagerState} from '../../store/file-manager.reducer';
import {
  ChooseFilesAction,
  DeleteFileAction, DownloadFileAction,
  LoadFilesAction,
  SelectFileAction,
  UnSelectFileAction
} from '../../store/file-manager.action';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {AskStringComponent} from "../../../../components/askString/askString.component";
import {IOuterNode} from "../../../angular2-tree/interfaces/IOuterNode";
import {FileManagerApiService} from "../../store/fileManagerApi.service";

@Component({
    standalone: false,
  selector: 'ri-file-component',
  templateUrl: './file.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FileComponent {
  @Input()
  public file: IFileModel;

  @Output()
  public onPreviewFile = new EventEmitter();

  @Output()
  public onSelectFile = new EventEmitter();

  @Input()
  public selectOnly: boolean = false;

  @Output()
  public externalSelect = new EventEmitter();

  public removeTitle = 'Remove file';

  public constructor(public configuration: FileManagerConfiguration,
                     public treeService: FileManagerApiService,
                     public store: Store<IFileManagerState>,
                     public dialog: MatDialog,
  ) {
  }

  /**
   * Fired when clicked on button "delete file"
   *
   * @param file
   */
  public deleteFile($event: MouseEvent, file: IFileModel) {
    this.store.dispatch(new DeleteFileAction({file}));

    $event.preventDefault();
    $event.stopPropagation();
  }

  public download($event: MouseEvent): void {
    this.store.dispatch(new DownloadFileAction({file: this.file}))
  }
  public renameFile($event: MouseEvent, file: IFileModel) {
    let config: MatDialogConfig = {
      width: "auto",
      height: "auto",
      data: {
        initialValue: file.name,
        title: "File Rename"
      }
    };

    let dialogRef = this.dialog.open(AskStringComponent, config);

    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        this.treeService.renameFile(<IOuterNode>((<any>file)._orgData), result).subscribe((newFile) => {
          this.store.dispatch(new LoadFilesAction({folderId: (<any>((<any>file)._orgData)).folderId}));
//        this.store.dispatch(new RenameFileAction({file}));
        })
      }
    });

    $event.preventDefault();
    $event.stopPropagation();
  }

  public getRemoveMessage(file: IFileModel) {
    return 'You are try to delete <b>' + file.name + '</b>. Are you sure?';
  }

  public openPreview($event: MouseEvent): void {
    let fileEvent: IFileEvent = {
      eventName: 'onPreviewFile',
      file: this.file
    };
    this.onPreviewFile.emit(fileEvent);

    $event.preventDefault();
    $event.stopPropagation();
  }

  public selectFile(): void {
    this.store.dispatch(new SelectFileAction({file: this.file}));
  }

  public unSelectFile(): void {
    this.store.dispatch(new UnSelectFileAction({file: this.file}));
  }

  public externalSelectFile($event: MouseEvent, file: IFileModel): void {
    if (!this.selectOnly) return;
    this.externalSelect.emit(file);

    $event.preventDefault();
    $event.stopPropagation();
  }

  public chooseFile($event: MouseEvent, file: IFileModel): void {
    if (!this.selectOnly) return;
    this.store.dispatch(new ChooseFilesAction({files: [file.toJSON()]}));

    $event.preventDefault();
    $event.stopPropagation();
  }
}
